import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraCarlosPaz from "../components/destinosSecciones/CabeceraCarlosPaz";
import HoteleriaVillaCarlosPazSecundario from "../components/hoteleria/HoteleriaVillaCarlosPazSecundario";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionVillaCarlosPazSec from "../components/diversion/DiversionVillaCarlosPazSec";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function SecVillaCarlosPaz() {
    return (
      <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/cordoba/cordoba2.jpg"}
        HeaderTitle="Villa Carlos Paz"
        Parent="secundarios"
        PageTitle="Villa Carlos Paz"
      />
      <CabeceraCarlosPaz destino={"Villa Carlos Paz"} />
      <VideoPromoDestino
        background="assets/img/villaCarlosPazSec/cordoba1Sec.jpg"
        YoutubeVideoId="Vec5k7AN7Dw"
        TextoPromo="Cordoba, tu viaje de egresados."
      />
      <HoteleriaVillaCarlosPazSecundario />
      <DiversionVillaCarlosPazSec hasBg={true} />
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
      );
}